export default __webpack_public_path__ + "locales/sl/PaymentsEnterprise.json?hash=d5afb340986c88f18ce299177c3b9b2b";